import { RoleName } from '@m/types/api/iam/Iam';
import { hasRoles } from 'apps/admin/permissions/RouteManager';

export default function useSuperAdminCheck() {
  return hasRoles([RoleName.SUPER_ADMIN]);
}
